module.exports = __webpack_public_path__ + "img/percogesic_backache_relief_pain_reliever_maximum_strength.5955c834.png";